import { getRequest } from './api'

const module = 'area'
export function getAreaList(params = {}) {
  const url = `${module}/tree`
  return getRequest(url, params)
}
